import type { ThemeWithColors } from "@/content-hub/theme/themes";

export const extractColor = (theme: ThemeWithColors, color: string) => {
  if (color?.startsWith("#")) {
    return color;
  }

  return theme?.colors[color] || color;
};
